import { useSearchParams } from 'react-router'
import { Panel } from '@components/Panel/Panel'
import type { Address } from 'viem'

import { InstallBotPage } from './InstallBotPage/InstallBotPage'

export const BotPagePanel = () => {
    const [searchParams] = useSearchParams()
    const appAddress = searchParams.get('profileId') as Address | null

    if (!appAddress) {
        return null
    }

    return (
        <Panel label="Bot" padding="none">
            <InstallBotPage appAddress={appAddress} />
        </Panel>
    )
}
